<div class="progress-container" [ngStyle]="containerStyle">
  <div class="progress-bar" [ngStyle]="progressStyle">
    <div class="shimmer-effect"></div>
  </div>
  <div class="progress-label" [ngStyle]="labelStyle" *ngIf="shouldShowLabel">
    {{currentValue}}/{{maxValue}}
  </div>
</div>
